// extracted by mini-css-extract-plugin
export default {"reactFlowWrapper":"organisationMapReactFlow_reactFlowWrapper__IsTSl","resetButton":"organisationMapReactFlow_resetButton__KSn3r"};